
export enum RschCnclReasonCd {
	CUSTOMER_REQUEST = 'Customer Request',
	EQUIPMENT_FAILURE = 'Equipment Failure',
	MISSED_PICKUP_BY_XPO = 'Missed Pickup by XPO',
	OTHER = 'Other',
	UNDEFINED = 'Undefined'}

